"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../utils/CardHelper");
function ProgressBar(applicationType, fillPercent, warningPercent, npsCategory) {
    if (npsCategory) {
        return CardHelper_1.CardHelper.create(adaptivecards_1.Image, {
            url: getNpsImageUrl(fillPercent, npsCategory),
        });
    }
    const prefix = applicationType === "msteams" ? "core_" : "";
    let fill = Math.min(Math.floor(fillPercent), 100);
    let status = "_";
    if (warningPercent) {
        if (fillPercent >= 100) {
            status = "_danger_";
        }
        else if (fillPercent >= warningPercent) {
            status = "_warning_";
        }
        else if (fillPercent === 0) {
            fill = "empty";
        }
    }
    return CardHelper_1.CardHelper.create(adaptivecards_1.Image, {
        url: `https://static.polly.ai/teams/img/progressbar/${prefix}progressbar${status}${fill}.png`,
    });
}
exports.ProgressBar = ProgressBar;
function getNpsImageUrl(fillPercent, npsCategory) {
    return `https://static.polly.ai/teams/img/progressbar/nps/${npsCategory}s_${fillPercent}.png`;
}
//# sourceMappingURL=ProgressBar.js.map